module.exports = __webpack_public_path__ + "static/008-d1befba0c36a96d5adfb942a172d8182.jpg";